import {FeatureAppConfigurationModel} from '../../../generated/core';
import {useCMSFeatureAppService} from '../../context';
import React from 'react';

export type LoadFeatureAppState = {
    loadingState: 'loading' | 'finished';
    featureApp: FeatureAppConfigurationModel | undefined;
};

export const useLoadFeatureAppConfig = (
    featureAppName: string | undefined
): LoadFeatureAppState => {
    const cmsFAService = useCMSFeatureAppService();

    const [featureAppConfigModel, setFeatureAppConfigModel] =
        React.useState<LoadFeatureAppState>({
            loadingState: 'loading',
            featureApp: undefined
        });

    React.useEffect(() => {
        if (!featureAppName) {
            setFeatureAppConfigModel({
                loadingState: 'finished',
                featureApp: undefined
            });
        } else {
            setFeatureAppConfigModel({
                loadingState: 'loading',
                featureApp: undefined
            });
            cmsFAService.getFeatureAppConfig(featureAppName).then(value => {
                setFeatureAppConfigModel({
                    loadingState: 'finished',
                    featureApp: value
                });
            });
        }
    }, [featureAppName, cmsFAService]);

    return featureAppConfigModel;
};
